/**
 * signalR全局连接
*/
import {Ticket} from '@/utils';
const signalR = require('@/assets/lib/signalr.js')

/**
 * new Socket($url, {maxRetry: 10, ...}
 */
class Socket {
    constructor(url, {
        maxRetry = 10
    } = {}) {
        this.maxRetry = maxRetry
        this.connection = ''
        this.url = url

        this._initConnection()
    }

    _initConnection() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.url, {
                accessTokenFactory: () => Ticket.get().access_token
            })
            .build()

        this.connection.onclose(error => this.onClose(error))
    }

    start() {
        return this.connection.start(signalR.TransferFormat.Text)
            .then(() => {
                Promise.resolve('success')
            })
            .catch(err => {
                console.log('Error opening connection：', err)

                if (this.maxRetry-- > 0) {
                    setTimeout(() => {
                        this.start()
                    }, 5000)
                }
            })
    }

    stop() {
        this.connection.stop().then(res => {}).catch(err => {})
    }

    onClose(error) {
        if (error) {
            // 连接时出现错误，尝试重连
            this.start()
            console.info('%s Connection closed with error: ' + error, 'background: red; color: white')
        } else {
            console.log('%c Disconnected by myself', 'color:green')
        }
    }

}


export default Socket
